import { Fragment } from "react";
import styled from "styled-components/macro";
import { FaWhatsapp } from "react-icons/fa6";
import { MdOutlineMailOutline } from "react-icons/md";
import { Box, Divider, Typography } from "@mui/material";

import Circle from "../../assets/footer_gradient.svg";
import Logo from "../../assets/auth carousel pics/footer.svg";
import BackToTop from "./sidebar components/BackToTop";

const Paper = styled.div`
  min-height: 75px;
  background: rgba(77, 77, 79, 1);
  border-radius: 0px;
  overflow: hidden;
  padding-top: 10px;
`;

const LowerPaper = styled.div`
  padding: 10px;
  min-height: 24px;
  background: #e1e1e1;
  width: 100%;
  align-self: center;
  justify-content: center;
  display: flex;
`;

const GridContainer = styled.div`
  height: 100%;
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const Image = styled.div`
  height: 72px;
  width: 187px;
  margin-left: 20px;
  position: relative;
  top: -7px;
`;

const ImageCircle = styled.div`
  width: 119px !important;
  height: 116px;
  overflow: hidden;
`;

const ContantDiv = styled.div`
  color: #fff;
  gap: 5px;
  display: grid;
`;

const Con = styled(Typography)`
  font-size: 15px;
  font-weight: 500;
  text-align: left;
`;

const Whatsapp = styled.a`
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
`;

const Email = styled.a`
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
`;

export default function Footer({ showButton, handleBackToTop }) {
  return (
    <Fragment>
      <Paper>
        <GridContainer>
          <Image>
            <img style={{ height: "100%", width: "100%" }} alt="1" src={Logo} />
          </Image>
          <ContantDiv>
            <Con>Contact Us</Con>
            <Divider
              sx={{ borderColor: "#fff" }}
              style={{
                width: "80px",
              }}
            />
            <Box display="flex" alignItems="center">
              <FaWhatsapp style={{ color: "#fff", fontSize: "14px" }} />
              &nbsp;
              <Whatsapp
                style={{ color: "#fff" }}
                target="_blank"
                href="https://api.whatsapp.com/send/?phone=628568863266&text&type=phone_number&app_absent=0"
              >
                Contact Us
              </Whatsapp>
            </Box>

            <Box display="flex" alignItems="center">
              <MdOutlineMailOutline
                style={{ color: "#fff", fontSize: "14px" }}
              />
              &nbsp;
              <Email
                style={{ color: "#fff" }}
                target="_blank"
                href="mailto:ida-partnership@ioh.co.id"
              >
                ida-partnership@ioh.co.id
              </Email>
            </Box>
          </ContantDiv>

          <div style={{ display: "flex" }}>
            <BackToTop
              showButton={showButton}
              handleBackToTop={handleBackToTop}
            />

            <ImageCircle>
              <img
                style={{ height: "100%", width: "100%" }}
                alt="1"
                src={Circle}
              />
            </ImageCircle>
          </div>
        </GridContainer>
      </Paper>
      <LowerPaper>
        <Typography style={{ fontSize: "14px" }}>
          {`Indosat Ooredoo Hutchison © ${new Date().getFullYear()} All rights reserved.`}
        </Typography>
      </LowerPaper>
    </Fragment>
  );
}
